// extracted by mini-css-extract-plugin
module.exports = {"topNav":"Customizations_topNav__2xvo2","editLink":"Customizations_editLink__3hdfk","removeLink":"Customizations_removeLink__2Ugpj","cloneLink":"Customizations_cloneLink__BxhqN"};